import { combineReducers } from 'redux';
import Module1Reducer from './module1Reducer';
import Module2Reducer from './module2Reducer';
import Module3Reducer from './module3Reducer';
import Module4Reducer from './module4Reducer';
import Module5Reducer from './module5Reducer';
import Module6Reducer from './module6Reducer';
import Module7Reducer from './module7Reducer';
import Module8Reducer from './module8Reducer';
import Module9Reducer from './module9Reducer';
import Module10Reducer from './module10Reducer';
import Module11Reducer from './module11Reducer';
import Module12Reducer from './module12Reducer';
import Module13Reducer from './module13Reducer';
import Module14Reducer from './module14Reducer';
import Module15Reducer from './module15Reducer';
import Module16Reducer from './module16Reducer';
import Module17Reducer from './module17Reducer';
import Module18Reducer from './module18Reducer';
import Module19Reducer from './module19Reducer';
import Module20Reducer from './module20Reducer';
import loginReducer from './loginReducer';
import redoReducer from './redoReducer';
import FreePlayReducer from './freeplayReducer';

const rootReducer = combineReducers({
  module1: Module1Reducer,
  module2: Module2Reducer,
  module3: Module3Reducer,
  module4: Module4Reducer,
  module5: Module5Reducer,
  module6: Module6Reducer,
  module7: Module7Reducer,
  module8: Module8Reducer,
  module9: Module9Reducer,
  module10: Module10Reducer,
  module11: Module11Reducer,
  module12: Module12Reducer,
  module13: Module13Reducer,
  module14: Module14Reducer,
  module15: Module15Reducer,
  module16: Module16Reducer,
  module17: Module17Reducer,
  module18: Module18Reducer,
  module19: Module19Reducer,
  module20: Module20Reducer,
  freeplay: FreePlayReducer,
  loginReducer,
  redoReducer,
});
export default rootReducer;
